const ParentState={
    parentData:{},
    isLoading:false,
    appointments:[],
    isPay:{}
}

export default ParentState;